import type { ApiEndpointKeyType } from './api-endpoint-key';
import { ApiEndpointKey } from './api-endpoint-key';

/**
 * Maps each API endpoint key to its documentation/health-check path (relative to origin).
 * Keys absent from this map are non-API endpoints (app URLs) and won't be health-checked.
 */
export const API_ENDPOINT_DOC_PATH: Partial<Record<ApiEndpointKeyType, string>> = {
  // Core / Shared
  [ApiEndpointKey.BD_PERMISSION_RESOURCE_URL]: '/api/',
  [ApiEndpointKey.BD_FILES_RESOURCE_URL]: '/api/',
  [ApiEndpointKey.BD_JOBS_RESOURCE_URL]: '/api/',
  [ApiEndpointKey.BD_DISTRICT_URL]: '/api/',
  [ApiEndpointKey.BD_AI_API_URL]: '/api/v3/api-docs',

  // Analytics — individual API hosts use '/api/', edge-api-gateway uses '/api/khbenchgateway/'
  [ApiEndpointKey.AYS_CODE_URL]: '/api/',
  [ApiEndpointKey.AYS_RESOURCE_URL]: '/api/khbenchgateway/',
  [ApiEndpointKey.AYS_CLINIC_RESOURCE_URL]: '/api/khbenchgateway/',
  [ApiEndpointKey.AYS_CLINIC_FILTER_STORAGE_URL]: '/api/',
  [ApiEndpointKey.AYS_CLINICS_CUBE_URL]: '/api/',
  [ApiEndpointKey.AYS_CODE_SPECTRUM_STORAGE_URL]: '/api/',
  [ApiEndpointKey.AYS_COMPETITORS_ANALYSIS_RESOURCE_URL]: '/api/khbenchgateway/',
  [ApiEndpointKey.AYS_COMPETITORS_ANALYSIS_CALCULATION_URL]: '/api/khbenchgateway/',
  [ApiEndpointKey.AYS_DEMAND_ANALYSIS_URL]: '/api/',
  [ApiEndpointKey.AYS_FAB_RESOURCE_URL]: '/api/khbenchgateway/',
  [ApiEndpointKey.AYS_MARKET_STORAGE_URL]: '/api/',
  [ApiEndpointKey.AYS_POTENTIAL_URL]: '/api/',
  [ApiEndpointKey.AYS_PROJECTION_RESOURCE_URL]: '/api/',
  [ApiEndpointKey.AYS_SCENARIO_ANALYSIS_RESOURCE_URL]: '/api/',
  [ApiEndpointKey.AYS_BENCHMARKING_GROUP_RESOURCE_URL]: '/api/',

  // Virtual Clinic
  [ApiEndpointKey.AYS_VIRTUAL_CLINIC_RESOURCE_URL]: '/api/',
  [ApiEndpointKey.AYS_VIRTUAL_CLINIC_REFERRAL_RESOURCE_URL]: '/api/',
  [ApiEndpointKey.AYS_VIRTUAL_CLINIC_REFERRAL_IMPORT_RESOURCE_URL]: '/api/',
  [ApiEndpointKey.AYS_VIRTUAL_CLINIC_P21_IMPORT_RESOURCE_URL]: '/api/',

  // Business
  [ApiEndpointKey.BD_BUSINESS_CASE_RESOURCE_URL]: '/api/',
  [ApiEndpointKey.CUBE_DASHBOARD_URL]: '/api/',
  [ApiEndpointKey.DRG_PROFIT_LOSS_ANALYSIS_RESOURCE_URL]: '/api/',

  // Country-specific
  [ApiEndpointKey.AT_CODE_SPECTRUM_API_URL]: '/api/',
  [ApiEndpointKey.AT_CUBE_DASHBOARD_API_URL]: '/api/',
  [ApiEndpointKey.AT_VIRTUAL_CLINIC_API_URL]: '/api/',
  [ApiEndpointKey.CH_CODE_API_URL]: '/api/',
  [ApiEndpointKey.CH_CODE_SPECTRUM_API_URL]: '/api/',
  [ApiEndpointKey.CH_CUBE_DASHBOARD_API_URL]: '/api/',
  [ApiEndpointKey.CH_VIRTUAL_CLINIC_API_URL]: '/api/',
  [ApiEndpointKey.UK_CODE_SPECTRUM_API_URL]: '/api/',

  [ApiEndpointKey.AYS_CLINIC_CASE_COUNT_URL]: '/api/',

  // Intentionally ABSENT: KOST_DATA_IMPORT_AT_APP,
  // KOST_DATA_IMPORT_CH_APP (app URLs, not APIs)
  // Legacy/removed: BMG_DEMAND_ANALYSIS_URL
  // Permission-gated: INTUITIVE_PP_EXPORTS_API (INTUITIVE_COMPETITOR_ANALYSIS only);
  // the diagnostics page is shown to every user, so it must not list this host.
};
